/* @ngInject */
const accountAsk = (
  $state,
  $uibModal,
  labels,
  routes,
  $$setting,
  authService,
  toaster,
  accountRequest,
  userService
) => {
  const self = {}

  self.tryLogin = false

  self.delete = (_account) => {
    if (toaster.confirm('Êtes-vous sûr de vouloir supprimer le compte ' + _account.username)) {
      userService.delete(_account)
    }
  }

  self.askLogin = () => {
    authService.logout()
    if (!authService.isLog() && !self.tryLogin) {
      self.tryLogin = true
      $uibModal.open({
        template: require('./login.html'),

        /* @ngInject */
        controller: (
          $scope,
          $uibModalInstance,
          accountMetadata
        ) => {
          $scope.fieldsOptions = accountMetadata.fields

          $scope.login = (_username, _password) => {
            accountRequest.login(_username, _password)
              .then((message) => {
                toaster.message(labels.account.welcome(_username))
                self.tryLogin = false
                const data = {
                  userId: authService.getUid(),
                }
                $$setting.requests.getBySearch(data)
                  .then((response) => {
                    $$setting.format.updateLocalWithDatabase(response.settings)
                    $$setting.format.updateGeneralWithDatabase(response.settings)
                  })
                  .catch((error) => {
                    console.error(error)
                  })
                $uibModalInstance.close()
              })
              .catch((error) => {
                console.log(error)
                toaster.error(error, true)
                $scope.password = ''
              })
          }

          $scope.close = () => {
            $uibModalInstance.close()
            self.tryLogin = false
            $state.go(routes.home.path)
          }
        },
      })
    }
  }

  return self
}
export default accountAsk



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/services/ask.service.js